import React, { FC } from 'react';
import { ReactComponent as Activate } from '../../../assets/Reprsentatives/activate.svg';

export const ActivateRepresentativeIcon: FC = () => <Activate />;
